import { render, staticRenderFns } from "./Orderdetails.vue?vue&type=template&id=265656ac&scoped=true"
import script from "./Orderdetails.vue?vue&type=script&lang=js"
export * from "./Orderdetails.vue?vue&type=script&lang=js"
import style0 from "./Orderdetails.vue?vue&type=style&index=0&id=265656ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265656ac",
  null
  
)

export default component.exports